{
  "bank": "บัตรธนาคาร",
  "alipay": "Alipay",
  "wechat": "WeChat",
  "ermb": "กระเป๋าเงินดิจิทัล",
  "qq": "QQ"
}
